var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5347",
    "data-name": "Group 5347",
    transform: "translate(-1210 -441)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5331",
    "data-name": "Group 5331",
    transform: "translate(1187 411)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_282",
    "data-name": "Rectangle 282",
    width: 70,
    height: 70,
    rx: 12.5,
    transform: "translate(23 30)",
    fill: "#e23744"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bell_3_",
    "data-name": "bell (3)",
    transform: "translate(1233 464)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3252",
    "data-name": "Path 3252",
    d: "M22.186,17.618a6.977,6.977,0,0,1-2.478-5.339v-2.9a7.3,7.3,0,0,0-6.25-7.208V1.042a1.042,1.042,0,0,0-2.083,0V2.167a7.3,7.3,0,0,0-6.25,7.208v2.9a6.985,6.985,0,0,1-2.488,5.347,1.823,1.823,0,0,0,1.185,3.207H21.01a1.823,1.823,0,0,0,1.176-3.216Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3253",
    "data-name": "Path 3253",
    d: "M12.153,24.125A3.912,3.912,0,0,0,15.98,21H8.326A3.912,3.912,0,0,0,12.153,24.125Z",
    transform: "translate(0.264 0.875)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notificationIcon.d6f0d11165c4323ba2c52ad5d9e6d7b1.svg";
export { ForwardRef as ReactComponent };